import { useAuthStore } from "@/Stores/AuthStore";

export const checkPermission = (
    haystack: string[] | null | undefined,
    permission: string
): boolean => {
    if (!haystack)
        return false;
    return haystack.includes(permission);
};

export const can = (permission: string): boolean => {
    return checkPermission(useAuthStore.getState().auth0User?.permissions, permission);
};

export const cant = (permission: string): boolean => {
    return !can(permission);
};

export const checkAllPermissions = (
    haystack: string[] | null | undefined,
    permissions: string[]
): boolean => {
    if (!haystack || !permissions.length)
        return false;
    for (const permission of permissions) {
        if (!checkPermission(haystack, permission)) {
            return false;
        }
    }
    return true;
};

export const checkAnyPermission = (
    haystack: string[] | null | undefined,
    permissions: string[]
): boolean => {
    if (!haystack || !permissions.length)
        return false;
    for (const permission of permissions) {
        if (checkPermission(haystack, permission)) {
            return true;
        }
    }
    return false;
};
